<script>
/**
 * ****************************************************************************
 * @description     :   Main component for popup MST_002
 * @created at      :   2026/02/12
 * @created by      :   longvv
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import store from '@/store';
import template from './template.html';
import { mapState, mapMutations, mapActions } from 'vuex';
import PopupMST002 from '@/views/popupSearch/PopupMST002/store';
import popupMST001Repository from '@/views/popupSearch/PopupMST001/repository';
import popupMST005Repository from '@/views/popupSearch/PopupMST005/repository';
import helpers from '@/utils/helpers';

var PopupMST002Index = {
    template: template,
    props: {
        onSelected: Function,
        id: String,
        initData: [String, Number, Object],
        isShowFooter: Boolean
    },
    beforeCreate() {
        if (!store.hasModule('PopupMST002')) {
            store.registerModule('PopupMST002', PopupMST002);
        }
    },
    created() {
        this.onInitScreen();
        this.applyInitData();
        this.loadInitReferData();
        this.onSearchItem();
    },
    data() {
        return {
            customer_name: '',
            department_name: ''
        };
    },
    emits: ['close', 'onReferModelValue', 'onReferValueName'],
    computed: {
        ...mapState('PopupMST002', ['listData', 'data', 'totalRows', 'msgNoData'])
    },
    methods: {
        ...mapMutations('app', ['showHeaderError', 'showModalMessage']),
        ...mapActions('PopupMST002', ['searchMst002Info']),
        ...mapMutations('PopupMST002', ['resetDataInit', 'setPageNavigation', 'setPageNo']),
        applyInitData() {
            this.customer_name = '';
            this.department_name = '';
            if (this.initData && typeof this.initData === 'object') {
                if (this.initData.company_cd !== undefined) {
                    this.data.company_cd = this.initData.company_cd;
                }
                if (this.initData.customer_cd !== undefined) {
                    this.data.customer_cd = this.initData.customer_cd;
                }
                if (this.initData.mdcd !== undefined) {
                    this.data.mdcd = this.initData.mdcd;
                }
            } else if (this.initData !== undefined && this.initData !== null) {
                this.data.company_cd = this.initData;
            }
        },
        async loadInitReferData() {
            await Promise.all([this.referCustomerInfo(this.data.customer_cd), this.referDepartmentInfo(this.data.mdcd)]);
        },
        onSearchItem() {
            this.setPageNavigation({
                currentPage: 1,
                perPage: this.data.pageSize
            });
            this.searchMst002Info(this.data);
        },
        changeCurrentPage(data) {
            this.data.pageNo = data.currentPage;
            this.data.pageSize = data.perPage;
            this.searchMst002Info(this.data);
        },
        onInitScreen() {
            helpers.removeAllRequireInput();
            this.resetDataInit();
            this.customer_name = '';
            this.department_name = '';
        },
        handleCustomerChange(index, value) {
            if (!value) {
                this.customer_name = '';
            }
        },
        handleDepartmentChange(index, value) {
            if (!value) {
                this.department_name = '';
            }
        },
        setCustomerName(value) {
            this.customer_name = value ?? '';
        },
        setDepartmentName(value) {
            this.department_name = value ?? '';
        },
        async referCustomerInfo(value) {
            if (!value) {
                this.customer_name = '';
                return;
            }

            try {
                const res = await popupMST001Repository.searchMst001Info({
                    company_cd: this.data.company_cd ?? '',
                    customer_cd: Number(value) || 0,
                    customer_name: '',
                    pageNo: 1,
                    pageSize: 10,
                    mode: 1
                });
                const result = res?.data?.Data?.data?.[0];
                if (result) {
                    this.data.customer_cd = result.customer_cd;
                    this.customer_name = result.customer_name ?? '';
                } else {
                    this.data.customer_cd = '';
                    this.customer_name = '';
                }
            } catch (e) {
                this.data.customer_cd = '';
                this.customer_name = '';
                console.log('referCustomerInfo: ' + e.message);
            }
        },
        async referDepartmentInfo(value) {
            if (!value) {
                this.department_name = '';
                return;
            }

            try {
                const res = await popupMST005Repository.searchAreaInfo({
                    company_cd: this.data.company_cd ?? '',
                    department_cd: value,
                    mode: 1,
                    pageNo: 1,
                    pageSize: 10
                });
                const result = res?.data?.Data?.data?.[0];
                if (result) {
                    this.data.mdcd = result.department_cd;
                    this.department_name = result.department_name ?? '';
                } else {
                    this.data.mdcd = '';
                    this.department_name = '';
                }
            } catch (e) {
                this.data.mdcd = '';
                this.department_name = '';
                console.log('referDepartmentInfo: ' + e.message);
            }
        },
        chooseItem(item) {
            this.$emit('onReferModelValue', item.location_cd);
            this.$emit('onReferValueName', item.location_name);
            this.$emit('close');
        }
    }
};
export default PopupMST002Index;
</script>

<style lang="scss">
@use '@/assets/scss/common/popup.scss' as *;
</style>
